module.exports = __webpack_public_path__ + "img/development_03.abfdd656.png";